import { SerializableObject } from './serializable-object';


/** The user token domain object. */
export class UserToken extends SerializableObject {
  id: string;
  clientId: string;
  clientName: string;
  clientVersion: string;
  clientEnvironment: string;
  authorized: Date;
  expires: Date;
}
